<script setup>
import { useRouter } from "vue-router"
import { storeToRefs } from "pinia"
import { watch } from "vue"
import { useConfigStore, useEpciCommuneStore, useOnlineStore, useUserStore } from "~/store/index"

await useUserStore().fetchUser()
// await useConfigStore().fetchConfig()

if (useConfigStore().maintenance) {
    const router = useRouter()
    router.replace("/")
}

// useOnlineStore().prepareOffline("archive-records", "dossiers")

const { currentEpciCommune } = storeToRefs(useEpciCommuneStore())
const { currentUser } = storeToRefs(useUserStore())

if (currentEpciCommune.value?.id && currentUser.value?.role === "admin") {
    useOnlineStore().prepareOffline("archive-records", "dossiers")
}
watch(currentEpciCommune, (newVal, old) => {
    if (newVal?.id !== old?.id) {
        useOnlineStore().prepareOffline("archive-records", "dossiers")
    }
})
watch(currentUser, () => {
    useEpciCommuneStore().fetchEpciCommunes()
})
</script>

<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>
